export default "__VITE_ASSET__BescCRtZ__"